const e={version:"v1.1.1-LTS",builder:"build-186526"};export default e;
